import React, { Component } from 'react'
import CacheKeys from '../cache/CacheKeys'
import CacheManager from '../cache/CacheManager'
import PublicPageUI from './PublicPageUI.js'

class PublicPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      pageMessageList: null,
    }
    // initial locale is saved so that locale change can be
    // handled in componentWillReceiveProps
    this.locale = this.props.context.locale
  }

  render() {
    return (
      <PublicPageUI
        context={this.props.context}
        className={this.props.className}
        messageList={this.props.messageList}
        backLink={this.props.backLink}
        headerText={this.props.headerText}
        headerMessageKey={this.props.headerMessageKey}
        headerMessageArgs={this.props.headerStringArgs}
        pageMessageList={this.state.pageMessageList}
        dimension={this.props.dimension}
        centered={this.props.centered}
        children={this.props.children}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getMessages(context)
  }

  UNSAFE_componentWillReceiveProps(props) {
    if (props.context.locale !== this.locale) {
      this.locale = props.context.locale
      this.getMessages(props.context)
    }
  }

  getMessages(context) {
    let arr = [
      'c_about',
      'c_pricing',
      'c_privacy',
      'c_terms',
    ]
    let keys = arr.join(',')

    let cacheManager = new CacheManager({
      resource: `/api/pub/messages/${keys}/locale/${context.locale}`,
      cacheKey: CacheKeys.Messages('t_pub_page', context.locale),
      callback: this.getMessagesCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getMessagesCallback = (response) => {
    this.setState({pageMessageList : response.messageList})
  }
}

export default PublicPageSF
